import "core-js/stable"
import "regenerator-runtime/runtime"
// import 'babel-polyfill'
// import Es6Promise from 'es6-promise'
import Vue from 'vue'
import App from './App.vue'
// import config from './config'
import router from './router'
import store from './store'

import SaApi from '@spero/spero-utils/src/helpers/sa-api'
import RootApi from './apis/root-api'
import config from "@/config"
import Wechat from '@spero/h5-wechat-sdk'
import ultronApi from './apis/api-urls/ultron-api'
import JinDaShiApi from './apis/jindashi-api'
import Global from './mixins/global'
import Message from '@spero/spero-utils/src/components/toast-message'
import Layer2 from '@spero/spero-utils/src/components/layer2'
import BGCOVER from '@/mixins/avatar-mixin'
import openinstallMixin from '@spero/spero-utils/src/mixins/openinstall-mixin'

// Es6Promise.polyfill()

Vue.use(RootApi)
Vue.use(JinDaShiApi)
Vue.use(SaApi, config.saApi)
Vue.use(Message)
Vue.use(Layer2)
Vue.use(Wechat)

Vue.mixin(Global)
Vue.mixin(BGCOVER)
Vue.mixin(openinstallMixin)

new RootApi(config.rootApi)
new JinDaShiApi(config.jindashiApi)
const BrowserLogger = require('alife-logger')
const __bl = BrowserLogger.singleton(
  {
    pid: 'bzskmg4rzq@b120c8d2e2f730f',
    appType: 'web',
    imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
    sendResource: true,
    enableLinkTrace: true,
    enableSPA: true,
    behavior: true,
    disabled: !process.env.VUE_APP_ENV || process.env.VUE_APP_ENV === 'test',
    environment: process.env.VUE_APP_ENV === 'production' ? 'prod' : process.env.VUE_APP_ENV === 'preview' ? 'pre' : (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') ? 'local' : 'daily'
  }
)
Vue.prototype.$__bl = __bl

if (process.env.VUE_APP_ENV !== 'production') {
  const VConsole = require('./helpers/vconsole')
  console.log('VConsole', VConsole)
}

Vue.config.productionTip = false
new Vue({
  router,
  store,
  wechat: new Wechat({
    appId: config.appid,
    platform: 'Hawkeye',
    debug: false,
    signatureURL: config.rootApi.baseURL + ultronApi.signatureURL.split(' ')[1],
    jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'hideAllNonBaseMenuItem', 'hideMenuItems', 'previewImage']
  }),
  render: h => h(App),
}).$mount('#app')
